import { Bound } from "lib/@components/binding/Bound"
import { AllowPrint } from "lib/@components/pdf/allow-print"
import { register } from "lib/routes/register"
import { Outlet } from "react-router-dom"
import { Box } from "@mui/material"
import { ExportSchedulePdfPage } from "./export-schedule-pdf-page"

export const authoringPdfRoute = register("/authoring-pdf", <AuthoringPdfLayout />)

authoringPdfRoute.register("export/:projectId/:scheduleId", <ExportSchedulePdfPage $lazy />)

function AuthoringPdfLayout() {
    return (
        <AllowPrint>
            <Bound isPDF={true} isAuthoringPdfExport={true}>
                <Box sx={{ overflow: "visible", height: "auto", margin: 0, padding: 0 }}>
                    <Outlet />
                </Box>
            </Bound>
        </AllowPrint>
    )
}
